<script setup lang="ts">
import type { Swiper } from 'swiper/types';

const swiper = useTemplateRef('swiper_ref');
defineExpose({
  swiper: computed(() => swiper.value?.swiper as Swiper | undefined),
});
const images = [
  '/images/gallery/FOT08301.webp',
  '/images/gallery/FOT08140-2.webp',
  '/images/gallery/box.webp',
  '/images/gallery/fitness-vybaveni.webp',
  '/images/masaze/index.webp',
  '/images/solarium/2.webp',
  '/images/sauna/bio.webp',
  '/images/steny/moon.webp',
  '/images/sal/index.webp',
  '/images/steny/lezecka.webp',
];
</script>

<template>
  <div class="h-min">
    <Swiper
      ref="swiper_ref"
      :opts="{
        breakpoints: {
          0: { slidesPerView: 1.25, spaceBetween: 4 },
          640: { slidesPerView: 1.5, spaceBetween: 16 },
        },
        centeredSlides: true,
        centeredSlidesBounds: true,
        grabCursor: true,
        keyboard: true,
        pagination: { enabled: true, type: 'progressbar' },
        injectStyles: [
          `
            :host(.swiper-index-gallery) .swiper {
              padding-bottom: calc(var(--spacing-r4) + 3px);
            }
            @media (width >= 40rem /* 640px */) {
              :host(.swiper-index-gallery) .swiper {
                padding-bottom: calc(var(--spacing-r8) + 3px);
              }
            }
            :host(.swiper-index-gallery) .swiper-pagination-progressbar {
              --swiper-pagination-progressbar-bg-color: var(--color-client-gray);
              top: auto !important;
              bottom: 0px;
              height: 3px;
              border-radius: 8px;
              overflow: hidden;
            }
            :host(.swiper-index-gallery) .swiper-pagination-progressbar-fill {
              --swiper-theme-color: var(--color-client-orange);
            }
          `,
        ],
      }"
      class="swiper-index-gallery cursor-grab"
    >
      <IndexGalleryCarouselSlide
        v-for="(img, i) in images"
        :key="i"
        :image="{ url: img, alt: `Gallery image number ${i + 1}` }"
      />
    </Swiper>
  </div>
</template>
